module.exports = __webpack_public_path__ + "img/t1-12.ece074f5.png";